import { TableLinkColumnDTO } from '../table/table-link-column-dto'
import { SlatAssessmentStatus } from './slat-assessment-status'

export class SlatHistoryTableDTO {
  clientId: string
  template: string
  presentationDate: string
  age: string
  presenterId: string
  presenterName: string
  notes: string
  editReport?: TableLinkColumnDTO
  viewReport?: TableLinkColumnDTO
  impactingFactors: string
  slatId: string
  assessmentStatus?: string
}
